import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import ImageCard from "../../components/card/ImageCard";
import FormItemInputTextarea from "../../components/form-item/form-item-input-textarea";
import FormButton from "../../components/FormButton";
import { useNotify } from "../../helper/notify";
import { GetFullMediaPath, requireRules } from "../../helper/method";
import { statusShowMock, tokenMock } from "../../helper/mock";
import PreviewFile from "../../components/PreviewFile";
import { $api } from "../../helper";
import { useNavigate, useSearchParams } from "react-router";

export default function AddBranch() {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const notify = useNotify();
  const navigate = useNavigate();
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/branch/",
  );
  const update = $api.useMutation("put", "/site-api/v1/branch/");
  const detail = $api.useMutation("get", "/site-api/v1/branch-detail/");
  const [file, setFile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ایجاد نظر ویژه");
    if (searchParams.get("u_id")) {
      detail.mutate({
        params: {
          query: {
            branch_u_id: searchParams.get("u_id") ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (detail.data?.data) {
      setFile([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(detail.data.data.image ?? ""),
          id: detail.data.data.u_id,
        },
      ]);
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
    }
  }, [detail.data]);

  const onFinish = (
    values: {
      title: string;
      address: string;
      is_central: boolean;
      iframe: string;
      status: string;
      slug: string;
    },
    redirect = true,
  ) => {
    const formData = new FormData();
    formData.append("address", values.address);
    formData.append("status", values.status);
    formData.append("slug", values.slug);
    formData.append("iframe", values.iframe);
    formData.append("is_central", values.is_central.toString());
    formData.append("title", values.title);
    if (searchParams.get("u_id")) {
      formData.append(
        "branch_u_id",
        searchParams.get("u_id")?.toString() ?? "",
      );
    }
    formData.append("image", file?.at(0)?.file ?? file?.at(0)?.fileUrl ?? "");
    if (!searchParams.get("u_id")) {
      mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/branch-list");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      update.mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/branch-list");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e, true)}
      initialValues={{
        is_central: "false",
      }}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به شعبه"
        title="اطلاعات اصلی شعبه"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            name={"title"}
            rules={requireRules("نام شعبه")}
            className="col-span-1"
            label="نام شعبه"
            inputProps={{
              placeholder: "لطفا نام شعبه خود را وارد کنید.",
            }}
          />
          <FormItemInput
            name={"slug"}
            rules={requireRules("نام اسلاگ")}
            className="col-span-1"
            label="اسلاگ"
            inputProps={{
              placeholder: "لطفا نام اسلاگ خود را وارد کنید.",
            }}
          />
          <FormItemInputTextarea
            name={"iframe"}
            rules={requireRules("iframe گوگل")}
            className="col-span-1"
            label="iframe گوگل"
            inputProps={{
              placeholder: "لطفا iframe گوگل خود را وارد کنید.",
              rows: 2,
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("وضعیت")}
            name={"is_central"}
            label="شعبه مرکزی"
            inputProps={{
              placeholder: "لطفا شعبه مرکزی خود را انتخاب کنید.",
              options: [
                {
                  label: "بله",
                  value: "true",
                },
                {
                  label: "خیر",
                  value: "false",
                },
              ],
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("وضعیت")}
            name={"status"}
            label="وضعیت"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش محصول خود را انتخاب کنید.",
              options: statusShowMock,
            }}
          />
          <FormItemInputTextarea
            rules={requireRules("آدرس")}
            label="آدرس"
            name={"address"}
            className="col-span-full"
            inputProps={{
              className: "resize-none!",
              rows: 4,
              placeholder: "لطفا آدرس خود را بنویسید...",
            }}
          />
        </div>
      </FormCard>
      <FormCard
        subTitle="تصویر مربوط به شعبه در نسخه‌های مختلف"
        title="تصویر شعبه"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <div className="col-span-1 flex h-fit flex-col gap-2">
            <ImageCard
              file={file}
              setFile={setFile}
              id="image1-1"
              name="desktop_image"
            />
            {file?.map((e, i) => (
              <div className="w-40 h-40">
                <PreviewFile
                  id={e.id}
                  setFile={setFile}
                  url={e.fileUrl}
                  key={"preview-category" + i}
                />
              </div>
            ))}
          </div>
        </div>
      </FormCard>
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
